/**
 * Feature 3 — "Developing Profile" state shown on the public profile URL
 * (`/v/<slug>`) when the publish gate has not yet been met.  Wired by F1
 * (Public Vendor Profile) — F3 ships the component so F1 doesn't have to.
 *
 * Spec §284-291: company name + city/state; "Developing Profile" heading;
 * locked body copy; NO score, NO trust labels, NO risk indicators, NO CTA.
 */
interface DevelopingProfileStateProps {
  vendorName: string;
  city?: string | null;
  state?: string | null;
}

export default function DevelopingProfileState({
  vendorName, city, state,
}: DevelopingProfileStateProps) {
  const location = city && state ? `${city}, ${state}` : (city || state || null);
  return (
    <div className="mx-auto max-w-2xl py-16 text-center">
      <div className="text-sm text-slate-500">
        {vendorName}
        {location ? <> &middot; {location}</> : null}
      </div>
      <h1 className="mt-2 text-3xl font-semibold text-slate-900">
        Developing Profile
      </h1>
      <p className="mt-4 text-slate-600">
        More data needed before a public score is available. This vendor is
        active on GuardGrade but hasn't yet built a sufficient track record.
      </p>
    </div>
  );
}
